export default __webpack_public_path__ + "static/media/menu-blue.f3b915e4.svg";